<template>
  <div class="event-def">
    <content-nav-bar class="header">
      <svgicon
        v-if="def.icon"
        class="level-item"
        :name="def.icon"
        width="30"
        height="30"
        :original="true">
      </svgicon>
      <svgicon v-else class="level-item" name="objects" width="30" height="30"></svgicon>
      <p class="is-size-4 level-item">{{ def.label }}</p>
    </content-nav-bar>
    <div class="def-description">
      <p v-if="def.description">{{ def.description }}</p>
      <p v-else></p>
      <a v-if="def.native" class="level" :href="def.native" target="_">
        <div class="level-left">
          <svgicon class="level-item" name="apple" width="25" height="25"></svgicon>
          <span class="level-item">Apple Documentation Link</span>
        </div>
      </a>
    </div>
    <div class="scroll-div">
      <div class="def-table">
        <field-definition-table :def="def"></field-definition-table>
      </div>
    </div>
  </div>
</template>

<script>
import FieldDefinitionTable from '@/components/analytics/FieldDefinitionTable.vue';
import ContentNavBar from '@/components/ContentNavBar.vue';

export default {
  name: 'EventDefinitionDetails',
  components: { FieldDefinitionTable, ContentNavBar },
  props: {
    def: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>

.scroll-div {
  overflow-y: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: top;
}

.event-def {
  display: flex;
  flex-direction: column;
  flex: 1;

  .def-description {
    flex: 0;
    padding: $content-padding;
    border-bottom: 2px solid $border-color;

    a {
      margin-top: 10px;
    }
  }

  .def-table {
    flex: 1;
  }
}

</style>
